module.exports = __webpack_public_path__ + "static/media/special_2.dab07839.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/special/special_2.csv
// module id = 738
// module chunks = 0